import React, { useEffect } from "react";
import { connect } from "react-redux";

import MainContentWrapper from "../../shared/components/main-content-wrapper/MainContentWrapper";
import { adminActions } from "../../redux/actions";
import Topbar from "../../layout/Topbar";
import Footer from "../../layout/Footer";

const FAQ = ({ FAQs, getFAQs }) => {
  useEffect(() => {
    getFAQs();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Topbar />
      <MainContentWrapper>
        <div className="container">
          <div className="about-us-heading">FAQ</div>
          {FAQs?.map((item, index) => {
            const isExpanded = index === 0; // First accordion is expanded by default
            return (
              <div
                key={item.id}
                className="accordion mt-2"
                id={`accordion${index}`}
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button gap-2 ${
                        isExpanded ? "" : "collapsed"
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapseAccordion${index}`}
                      aria-expanded={isExpanded}
                      aria-controls={`collapseAccordion${index}`}
                    >
                      {item.question}
                    </button>
                  </h2>
                  <div
                    id={`collapseAccordion${index}`}
                    className={`accordion-collapse collapse ${
                      isExpanded ? "show" : ""
                    }`}
                    data-bs-parent={`#accordion${index}`}
                  >
                    <div className="accordion-body">{item.answer}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </MainContentWrapper>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => ({
  FAQs: state.adminReducer.FAQs,
});

const mapDispatchToProps = (dispatch) => ({
  getFAQs: () => dispatch(adminActions.getFAQs()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FAQ);
